import ApiService from '@/services/core/api.service'

const ClusterService = {
  async get (query) {
    return ApiService.get(`marketing-officer/clusters?${query}`)
  },

  async post (payload) {
    return ApiService.post('marketing-officer/clusters', payload)
  },

  async put (payload) {
    return ApiService.put(`marketing-officer/clusters/${payload.id}`, payload)
  },

  async delete (payload) {
    return ApiService.delete(`marketing-officer/clusters/${payload.id}`)
  }
}

export default ClusterService
